import React from "react";
import InputBox from "../commonComponents/inputComponents/InputBox";

import "./licensePlate.css";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

import { createTheme, FormControl, ThemeProvider } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

import { useTheme } from "../../contexts/ThemeContext";

const LicensePlateInput = React.forwardRef((_, ref) => {
  const {
    carIdFirstTwoStringRef,
    carIdMiddleStringRef,
    carIdLastThreeStringRef,
    carIdPlaceRef,
  } = ref;

  const { theme } = useTheme();

  const Mtheme = createTheme({
    direction: "rtl",
  });

  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  const licenseLetter = [
    "الف",
    "ب",
    "پ",
    "ت",
    "ث",
    "ج",
    "د",
    "ز",
    "ژ",
    "س",
    "ص",
    "ط",
    "ع",
    "ف",
    "ق",
    "ک",
    "گ",
    "ل",
    "م",
    "ن",
    "و",
    "ه",
    "ی",
  ];

  const letterList = licenseLetter.map((val) => (
    <MenuItem key={val} value={val}>
      {val}
    </MenuItem>
  ));

  return (
    <div className="license-container">
      <span className="license-title">شماره پلاک</span>
      <span className="license-country">ایران</span>
      <InputBox
        gap="0"
        persianNum={true}
        placeHolder="13"
        center={true}
        ref={carIdPlaceRef}
        maxChar={2}
      />
      <InputBox
        gap="0"
        persianNum={true}
        placeHolder="123"
        center={true}
        maxChar={3}
        ref={carIdLastThreeStringRef}
      />
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={Mtheme}>
          <FormControl
            variant="standard"
            fullWidth
            className="form-date-selector"
          >
            <Select
              id="select-year"
              defaultValue="ب"
              MenuProps={{
                className: `drop-menu ${theme === "light" ? "light-drop" : ""}`,
              }}
              IconComponent={() => null}
              inputRef={carIdMiddleStringRef}
            >
              {letterList}
            </Select>
          </FormControl>
        </ThemeProvider>
      </CacheProvider>
      <InputBox
        gap="0"
        persianNum={true}
        placeHolder="12"
        center={true}
        ref={carIdFirstTwoStringRef}
        maxChar={2}
      />
    </div>
  );
});

export default LicensePlateInput;
